<template>
    <div class="inline-input" v-on-clickaway="resetValue">
        <div class="files-manager-header border-0" v-if="showInput">
            <div class="search w-100">
                <input ref="inputElm" type="text" class="form-control" v-model="value" v-on:keyup.enter="updateValue" />
                <button v-on:click="updateValue" type="submit" class="btn-icon"><i class="font-icon font-icon-ok"></i></button>
                <!-- <span v-on:click="updateValue" class="input-group-text"> -->
                <!--     <i class="material-icons">edit</i> -->
                <!-- </span> -->
                <!-- <span v-on:click="resetValue" class="input-group-text"><i class="font-icon font-icon-del inline-input-icon"/></span> -->
            </div>
        </div>
        <div v-on:click="edit" v-else>
            <p class="inline-input-text" v-if="!!value">{{value}}</p>
            <p class="inline-input-text" v-else v-html="placeholder"></p>
            <i class="material-icons inline-input-icon">edit</i>
        </div>
    </div>
</template>
<script>
import Vue from 'vue';
import { mixin as clickaway } from 'vue-clickaway';

export default {
    data() {
        return {
            value: this.initialValue,
            showInput: false,
        }
    },

    props: ['initialValue', 'config'],

    mixins: [clickaway],

    watch: {
        initialValue(val) {
            this.value = val;
            this.showInput = false;
        }
    },

    computed: {
        placeholder() {
            return _.get(this.config, 'placeholder', '<i>Add caption</i>');
        },
    },

    methods: {
        edit() {
            this.showInput = true;
            this.$nextTick(() => {
                this.$refs['inputElm'].select();
            })
        },

        updateValue() {
            this.$emit('change', this.value);
            this.showInput = false;
        },

        resetValue() {
            this.value = this.initialValue;
            this.showInput = false;
        },
    }
}
</script>



// WEBPACK FOOTER //
// seventytwo/72cms-ui/src/components/helpers/InlineInputComponent.vue